import { combineReducers } from 'redux';

import { authReducer } from '~/components/Auth';
import { userSettingsReducer } from '~/components/UserSettings';
import { appearanceReducer } from '~/data/appearance';
import { applicationConfigReducer } from '~/data/applicationConfig';
import { companyDataReducer } from '~/data/company';
import { companyPreferencesReducer } from '~/data/companyPreferences';
import { costCenterReducer } from '~/data/costCenters';
import { customTranslationsReducer } from '~/data/customTranslations';
import { employeeReducer } from '~/data/employee';
import { employeeProfileReducer } from '~/data/employeeProfile';
import { employeesReducer } from '~/data/employees';
import { enumsReducer } from '~/data/enums';
import { languagesReducer } from '~/data/languages';
import { legalEntityReducer } from '~/data/legalEntity';
import { orgUnitReducer } from '~/data/orgunits';
import { unitPositionReducer } from '~/data/unitPositions';
import { userActivityReducer } from '~/data/userActivity';
import { workflowConfigReducer } from '~/data/workflows';
import { swrReducer } from '~/hooks/useSWR';
import { surveyReducer } from '~/legacy-components/TopbarSurvey';
import { myWorkspaceReducer } from '~/scenes/MyWorkspace';

import { entityAttributes } from './data/attributes/slice';

export const rootReducer = combineReducers({
  auth: authReducer,
  userSettings: userSettingsReducer,
  myWorkspace: myWorkspaceReducer,
  swr: swrReducer,
  survey: surveyReducer,
  orgUnits: orgUnitReducer,
  employees: employeesReducer,
  employee: employeeReducer,
  companyData: companyDataReducer,
  companyPreferences: companyPreferencesReducer,
  applicationConfig: applicationConfigReducer,
  enums: enumsReducer,
  costCenters: costCenterReducer,
  unitPositions: unitPositionReducer,
  employeeProfile: employeeProfileReducer,
  appearance: appearanceReducer,
  languages: languagesReducer,
  legalEntities: legalEntityReducer,
  workflow: workflowConfigReducer,
  userActivity: userActivityReducer,
  customTranslations: customTranslationsReducer,
  entityAttributes: entityAttributes,
});

export type StoreState = ReturnType<typeof rootReducer>;
